var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('business-trip-request-employee-form',{attrs:{"exclude":_vm.employees,"refreshable":""},on:{"input":_vm.change,"close":_vm.close,"save":_vm.save,"refresh":_vm.refresh},model:{value:(_vm.employee),callback:function ($$v) {_vm.employee=$$v},expression:"employee"}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51653c56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business-trip/BusinessTripRequestEmployeeNew.vue
// module id = null
// module chunks = 